<div class="bloco">
    <h5 class="titulo">Histórico de Razão Social</h5>
    <div *ngIf="naoEncontrouRegistros">
        <div class="row">
          <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
        </div>
    </div>
    <div *ngIf="naoSolicitou">
        <div class="row">
            <div class="col-auto item">Você não solicitou essa consulta.</div>
          <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
        </div>
    </div>
    <div *ngIf="dados.historico_razao_social">
      <div class="row">
        <table class="table table-sm ">
          <thead>
            <tr>
              <th>CNPJ</th>
              <th>Última razão social</th>
              <th>Data de modificação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dados.historico_razao_social">
              <!-- <td id="documentoFilial">
                <i class="fas fa-search"></i> 
                <a 
                  href="javascript:void(0)" 
                  tooltip="Clique aqui para consultar este documento {{row.cnpj_filial | mascara:'cnpj'}}"
                  (click)="capturaDoc(row.cnpj_filial)"
                  routerLink="/area-logada/consultas"> 
                    {{row.cnpj_filial  | mascara:'cnpj'}}
                </a>
              </td> -->
              <td>{{row.cnpj | mascara:'cnpj'}}</td>
              <td>{{row.ultima_razao_social}}</td>
              <td>{{row.data_modificacao}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
    
    